import { createRecipeSlug } from "../../base/utils";
import { Link } from "react-router-dom";
import logo from "../../images/BlogFreeRecipe-drkBkgrd.png";
import RecipeBadges from "./RecipeBadges";

const createRecipeUrl = (recipe) => {
  const slug = createRecipeSlug(recipe);
  return slug ? `/recipes/${slug}` : `/recipeDetails/${recipe?.id}`;
};
const RecipeCollapsed = ({ recipe, badges }) => {
  const mainPicture =
    recipe.main_picture || recipe.additional_pictures?.[0] || logo;

  const recipeUrl = createRecipeUrl(recipe);
  return (
    <div className="Row">
      <img alt="small main" src={mainPicture} className="Small-Logo" />
      <div className="Column Space-B">
        <Link to={recipeUrl}>
          <h5 className="Width-10 Shrink-Header">{recipe.recipe_name}</h5>
        </Link>
        <div className="Row P-R-B-L-5 Div-Parent-Badge">
          {badges?.map((badge) => {
            return <RecipeBadges key={`${badge.id}-${recipe.id}`} badge={badge} header={true} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default RecipeCollapsed;
